export default __webpack_public_path__ + "static/media/plant.e58beeb3.svg";